module.exports = __webpack_public_path__ + "img/wish_02.89bfc17f.png";